import { useEffect, useState } from 'react';
import { AuctionUtils } from 'src/pages/Auction/AuctionUtils';

export function useAuctionCloseCountDown(closeDate?: string): boolean {
  const [isClosed, setIsClosed] = useState(() =>
    AuctionUtils.isAuctionClosed(closeDate)
  );

  useEffect(() => {
    if (!closeDate) {
      return;
    }

    const interval = setInterval(
      () => setIsClosed(AuctionUtils.isAuctionClosed(closeDate)),
      500
    );

    return () => clearInterval(interval);
  }, [closeDate]);

  return isClosed;
}
